import {NgModule} from '@angular/core';
import {CommonModule, NgClass, NgForOf, NgIf, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {RouterLink} from '@angular/router';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        NgIf,
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        ReactiveFormsModule,
        NgClass,
        NgStyle,
        NgSelectModule,
        RouterLink
    ],
    exports: [
        CommonModule,
        NgIf,
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
        ReactiveFormsModule,
        NgClass,
        NgStyle,
        NgSelectModule,
        RouterLink
    ]
})
export class DeprecatedSharedUtilsModule {
}
